import * as React from "react";
import { RioIf, RioApiGet, RioExpandingPanel, RioResources, RioInput, RioSelect, RioApiPost, RioDateHelpers, RioValidator, RioIcon, RioCheckbox, RioIconButton } from "rio.react.all";
import { LandingWineType } from "../enums/LandingWineType";
import { Page } from "../components/Page";
import { LandingWineCampaignEmailApiModel } from "../apiModels/LandingWineCampaignEmailApiModel";
import { DataVineGridView } from "../components/GridView/GridView";
import { IGridViewColumn } from "../components/GridView/IGridViewColumn";
import { IGridViewAction } from "../components/GridView/IGridViewAction";
import { LandingWineTemplateApiModel } from "../apiModels/LandingWineTemplateApiModel";

interface ILandingWineEmailHistoryProps {
}

interface ILandingWineEmailHistoryState {
	searchString: string;
	searchEmail: string;
	templateID: number;
	formCompleted: boolean;
	results: Array<LandingWineCampaignEmailApiModel>;
	templates: Array<LandingWineTemplateApiModel>;
}

export class LandingWineEmailHistory extends React.Component<ILandingWineEmailHistoryProps, ILandingWineEmailHistoryState> {
	constructor(props: Readonly<ILandingWineEmailHistoryProps>) {
		super(props);

		this.state = {
			searchString: "",
			searchEmail: "",
			templateID: LandingWineType.Undefined,
			formCompleted: null,
			results: null,
			templates: null
		};
	}

	private validator = new RioValidator();

	columns: Array<IGridViewColumn<LandingWineCampaignEmailApiModel>> = [
		{ title: RioResources.find("CustomerNo").text, displayValue: (item) => item.customerNo, value: (item) => item.customerNo },
		{ title: RioResources.find("CustomerName").text, displayValue: (item) => item.customerName, value: (item) => item.customerName },
		{ title: RioResources.find("Email").text, displayValue: (item) => item.email, value: (item) => item.email },
		{ title: RioResources.find("TemplateSubject").text, displayValue: (item) => item.templateSubject, value: (item) => item.templateSubject },
		{ title: RioResources.find("SentDate").text, displayValue: (item) => RioDateHelpers.toDateFormat(item.sentDate, "DD/MM/YYYY"), value: (item) => item.sentDate },
		{ title: RioResources.find("FormCompleted").text, displayValue: (item) => (item.formCompleted ? < RioIcon resource={RioResources.find("Complete")} className="FormCompletedTick" /> : '' ), value: (item) => item.formCompleted },
	];

	actions: Array<IGridViewAction<LandingWineCampaignEmailApiModel>> = [
		{ resource: RioResources.find("Complete"), onClick: (item) => this.handleSetCompleteClicked(item), hasPermission: true, visible: (item) => !item.formCompleted },
	];

	render() {
		return (
			<Page heading={RioResources.find("HistorySearch")}>
				<React.Fragment>
					<div className="no-padding">
						<div className="form-row side-by-side-auto-width">
							<div>
								<label className="SearchAccountLabel SearchItem">{RioResources.find("SearchAccount").text}</label>
								<RioInput name="Title" type="text" className="SearchAccountInput SearchInput SearchItem" value={this.state.searchString}
									placeholder={RioResources.find("SearchPlaceholder").text}
									onChange={(e) => this.handleSearchChanged(e.target.value)}
									validations={{ required: true, maxLength: 255 }} />
							</div>
							<div>
								<label className="SearchTypesLabel SearchItem">{RioResources.find("SearchTemplates").text}</label>

								<RioIf condition={!!this.state.templates} then={
									<RioSelect<LandingWineTemplateApiModel>
										name="TemplateList"
										items={this.state.templates}
										value={!!this.state.templateID ? [this.state.templates.find(i => i.landingWineTemplateID == this.state.templateID) ?? undefined] : []}
										keySelector={(item: LandingWineTemplateApiModel) => { return item.landingWineTemplateID.toString() }}
										descriptionSelector={(item: LandingWineTemplateApiModel) => { return this.getTemplateDescription(item); }}
										onSuggestionSelected={(value: LandingWineTemplateApiModel) => { this.handleTemplateIDChanged(value.landingWineTemplateID) }}
										validator={this.validator}
										validations={{ required: false }}
										keepOptionsOpenOnSelected={false}
										isMultiSelect={false}
									/>
								} />


							</div>
						</div>
						<div className="form-row side-by-side-auto-width">
							<div>
								<label className="SearchEmailLabel SearchItem">{RioResources.find("SearchEmail").text}</label>
								<RioInput name="Title" type="text" className="SearchEmailInput SearchInput SearchItem" value={this.state.searchEmail}
									placeholder={RioResources.find("SearchPlaceholder").text}
									onChange={(e) => this.handleEmailChanged(e.target.value)}
									validations={{ required: true, maxLength: 255 }} />
							</div>
							<div>
								<label className="SearchEmailLabel SearchItem">{RioResources.find("FormCompleted").text}</label>
								<RioCheckbox checked={this.state.formCompleted} onChange={() => this.handleCompletedCheckboxChenged()} />
							</div>
							<div>
								<RioIconButton resource={RioResources.find("Search")} hideImage={true} onClick={() => this.handleSearchClicked()} hasPermission={true} className="SearchButton" />
							</div>
						</div>
					</div>

					<RioIf condition={!!this.state.results} then={
						<RioExpandingPanel
							className="noBackground showTitle"
							disableToggle={true}
							expandedDefault={true}
							title=''
							actions={[]}
						>
							<DataVineGridView<LandingWineCampaignEmailApiModel>
								noResults={RioResources.find("NoResultsFound")}
								columns={this.columns}
								actions={this.actions}
								items={this.state.results}
								rowKey={(item: LandingWineCampaignEmailApiModel) => item.landingWineCampaignEmailID}
								pageSize={50}
							/>
						</RioExpandingPanel>
					} />

				</React.Fragment>
			</Page>
		);
	}

	componentDidMount() {
		this.loadTemplates();
	}

	loadTemplates() {
		RioApiGet.asPromise<Array<LandingWineTemplateApiModel>>("/api/LandingWineTemplate/Get/")
			.then((response) => {
				let anyOption: LandingWineTemplateApiModel = {
					landingWineTemplateID: 0,
					daysBeforeSend: 0,
					active: false,
					landingWineTypeID: LandingWineType.Undefined,
					subject: RioResources.find("AnyWineTemplate").text,
					emailContent: null,
					deleted: false,
					createDate: null,
					lastActionDate: null,
					createUserID: 0,
					lastActionUserID: 0,
				};

				response.sort((a, b) => {
					if (a.landingWineTypeID > b.landingWineTypeID) {
						return -1;
					} else if (a.landingWineTypeID < b.landingWineTypeID) {
						return 1;
					} else {
						// If ages are the same, sort by name
						if (a.subject.toLowerCase() < b.subject.toLowerCase()) {
							return -1;
						} else if (a.subject.toLowerCase() > b.subject.toLowerCase()) {
							return 1;
						} else {
							return 0;
						}
					}
				});

				response.unshift(anyOption);

				this.setState({
					templates: response
				});
			})
			.catch((response) => {
			});
	}

	search() {
		let query = {
			customerNo: this.state.searchString,
			templateID: this.state.templateID,
			email: this.state.searchEmail,
			formCompleted: this.state.formCompleted,
		};

		RioApiPost.asPromise<Array<LandingWineCampaignEmailApiModel>>("/api/LandingWineCampaign/SearchHistory/", query)
			.then((response) => {
				this.setState({
					results: response
				});
			})
			.catch((response) => {
			});
	}

	handleSearchChanged(searchString: string) {
		this.setState({
			searchString: searchString
		});
	}

	handleTemplateIDChanged(templateID: number) {
		this.setState({
			templateID: templateID
		});
		this.forceUpdate();
	}

	handleEmailChanged(searchEmail: string) {
		this.setState({
			searchEmail: searchEmail
		});
	}

	handleCompletedCheckboxChenged() {
		let newValue: boolean;
		if (this.state.formCompleted == null) {
			newValue = true
		} else if (this.state.formCompleted) {
			newValue = false
		} else {
			newValue = null
		}

		this.setState({
			formCompleted: newValue
		});
	}

	handleSearchClicked() {
		this.search();
	}

	handleSetCompleteClicked(item: LandingWineCampaignEmailApiModel) {
		
		RioApiPost.asPromise<Array<LandingWineCampaignEmailApiModel>>("/api/LandingWineCampaign/SetAsComplete/", item.landingWineCampaignID)
			.then((response) => {
				//let index = this.state.results.indexOf(item);
				//let updatedResults = this.state.results;
				//updatedResults[index].formCompleted = true;

				//this.setState({
				//	results: updatedResults
				//});
				
				this.search();
			})
			.catch((response) => {
			});
	}

	getTemplateDescription(item: LandingWineTemplateApiModel) {
		let description: string = '';

		if (item.landingWineTypeID == LandingWineType.Ep) {
			description = RioResources.find("SearchEp").text + ' - ';
		}
		else if (item.landingWineTypeID == LandingWineType.NonEp) {
			description = RioResources.find("SearchNonEp").text + ' - ';
		}

		return description + item.subject;
	}
}
